import { render, staticRenderFns } from "./bookings-serviceorders-link.vue?vue&type=template&id=7bda8730&"
import script from "./bookings-serviceorders-link.vue?vue&type=script&lang=js&"
export * from "./bookings-serviceorders-link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports